// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gev7","question":"styles_question__q7yt8","description":"styles_description__1EluR"};